import type { ReactNode } from "react";

import type { DealSignalCsvValidation } from "../../types/model";

import type { DealSignalModalStep, FilterPanelState } from "./types";

export const resolveModalStep = (
    file: File | undefined,
    validation: DealSignalCsvValidation | undefined,
    isValidating: boolean,
): DealSignalModalStep => {
    if (isValidating || file === undefined || validation === undefined) {
        return { kind: "upload", isValidating };
    }

    if (!validation.isValid) {
        return {
            kind: "upload",
            isValidating: false,
            validationError: { reason: validation.reason, companiesCount: validation.companiesCount },
        };
    }

    return { kind: "confirm", fileName: file.name, companiesCount: validation.companiesCount };
};

export const toPanelState = (
    isPending: boolean,
    isError: boolean,
    onRetry: VoidFunction,
    renderPanel: () => ReactNode,
): FilterPanelState => {
    if (isPending) {
        return { status: "pending" };
    }

    if (isError) {
        return { status: "error", onRetry };
    }

    return { status: "success", renderPanel };
};
